import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, watch } from "vue";
export default {
  __name: 'BlackSwitch',
  props: {
    value: Boolean,
    size: {
      type: String,
      default: "default"
    }
  },
  setup(__props) {
    const props = __props;
    const model = ref(props.value);
    watch(() => props.value, newValue => {
      model.value = newValue;
    });
    return (_ctx, _cache) => {
      const _component_el_switch = _resolveComponent("el-switch");
      return _openBlock(), _createBlock(_component_el_switch, {
        modelValue: model.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => model.value = $event),
        size: __props.size,
        onChange: _cache[1] || (_cache[1] = $event => _ctx.$emit('update:value', $event))
      }, null, 8, ["modelValue", "size"]);
    };
  }
};